import request from "@/utils/request";

export default {
  // 查询
  getQspiQueryPage: (param) => {
    return request({
      url: `/qspiFacilityFactorScore/queryPage`,
      method: "post",
      data: param,
    });
  },
  getAuditQueryPage: (param) => {
    return request({
      url: `/qspiAuditInfo/list`,
      method: "post",
      data: param,
    });
  },
  auditSave: (param) => {
    return request({
      url: `/qspiAuditInfo/save`,
      method: "post",
      data: param,
    });
  },
  auditDel: (param) => {
    return request({
      url: `/qspiAuditInfo/delete`,
      method: "post",
      data: param,
    });
  },
  getAuditDetail: (id) => {
    return request({
      url: `qspiAuditInfo/detail/${id}`,
      method: "get",
    });
  },
  getSupplierId: (param) => {
    return request({
      url: "/supplier/selectPage",
      method: "post",
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
      },
      data: param,
    });
  },
  // 更新最高等级
  problemLevelRefresh: (param) => {
    return request({
      url: `/qspiProductFeedback/problemLevelRefresh`,
      method: "post",
      data: param,
    });
  },
  // 历史详情
  getQspiHistoryList: (param) => {
    return request({
      url: `/qspiFacilityFactorScore/queryHistoryList`,
      method: "post",
      data: param,
    });
  },
  // 查看详情
  findQspiDetail: (param) => {
    return request({
      url: `/qspiFacilityFactorScore/findDetail`,
      method: "post",
      data: param,
    });
  },
  //保存评分
  saveQspiScore: (param) => {
    return request({
      url: `/qspiFacilityFactorScore/saveBatchOrOne`,
      method: "post",
      data: param,
    });
  },
  // 获取指标类型
  getFacotrList: (param) => {
    return request({
      url: `/qspiFacilityFactorScore/getFacotrList`,
      method: "post",
      data: param,
    });
  },
  // 批量提交
  batchSubmit: (param) => {
    return request({
      url: `/qspiFacilityFactorScore/submit`,
      method: "post",
      data: param,
    });
  },
  // 根据分数生成等级
  findGradeToScore: (type, score) => {
    return request({
      url: `/qspiFacilityFactorScore/findGrade/${type}/${score}`,
      method: "post",
      data: {},
    });
  },
  exportQspiFacilityFactorScore: (param) => {
    return request({
      url: `/qspiFacilityFactorScore/exportQspiFacilityFactorScore`,
      data: param,
      method: "post",
      responseType: "blob",
      fullResponse: true,
    });
  },
};
